import {
  RAZER_GAMES,
  EXTERNAL_CHECK_GAMES,
  PARALLEL_REQUESTS_GAMES,
} from '@page_detail/config'

const SKUID_GAMES = [
  'hago',
  'shining-nikki',
  'star-maker',
  'tinder',
  'game-of-sultans',
  'game-of-khans',
  ...RAZER_GAMES,
]

const CPSERID_GAMES = [
  'turbo-vpn',
  'vpn-proxy-master',
  'guardians-of-cloudia',
  'dragonheir',
  'kungfu-legend',
  'genshin',
  'dummy-product',
  'goddess-of-victory-nikke',
  'honkai-star-rail',
  'zenless-zone-zero',
  'eggy-party',
  'arena-breakout-dc',
]
const ALLS_GAMES = ['mobile-legends']

// tips: 默认校验UID的时候、需要拦截SKUID是否存在
export const NEED_SKUID = [...SKUID_GAMES, ...ALLS_GAMES]

// 新版check-user接口的处理的公共参数的方法
export function createUidParames(parames = {}) {
  const {
    gameName = '',
    uid = '',
    selectSkuItem = {},
    selectServerItem = {},
  } = parames

  const { skuId = '' } = selectSkuItem
  const args = {
    gameName,
    uid,
    skuId,
  }
  if (gameName === '' || uid === '') {
    throw Error('请注意：UID || gameName 比传项')
  }
  const { cpServerId = '', serverName } = selectServerItem // zoneId 需要兼容MLBB

  if (EXTERNAL_CHECK_GAMES.includes(gameName)) {
    return {
      ...args,
      cpProductInfo: JSON.stringify(selectSkuItem),
    }
  }
  if (SKUID_GAMES.includes(gameName)) {
    return {
      ...args,
      skuId,
    }
  }

  if (CPSERID_GAMES.includes(gameName)) {
    return {
      ...args,
      cpServerId,
      serverName,
    }
  }

  if (ALLS_GAMES.includes(gameName)) {
    return {
      ...args,
      cpServerId,
      skuId,
    }
  }

  if (PARALLEL_REQUESTS_GAMES.includes(gameName)) {
    return {
      ...args,
      cpServerId,
    }
  }

  return args
}
